namespace Solovis.Reports.StandardDataSources {

    export function getSelectionSetDataSource(options) {
        var dataSourceName = options.dataSourceName;
        var selectionSetParameterName = options.selectionSetParameterName;
        var dayIdParameterName = options.dayIdParameterName;
        var includeResourceIds = options.includeResourceIds ? true : false;
        var includeAssetsAsParameterList = options.includeAssetsAsParameterList ? true : false;

        var dataSourceForSelectionSetContents = {
            name: dataSourceName,
            path: "/Solovis/Metadata/AssetSelectionSetContents",

            parameterMap: function (parameters) {
                if (!parameters[selectionSetParameterName]) {
                    return null;
                }
                else {
                    var params: any = {};

                    var assetSelectionSet = parameters[selectionSetParameterName];

                    if (assetSelectionSet.id) {
                        params.assetSelectionSetId = assetSelectionSet.id;
                    }
                    else if (assetSelectionSet.custom) {
                        params.assetSelectionSetData = assetSelectionSet.custom;
                    }

                    if (dayIdParameterName) {
                        params.dayId = parameters[dayIdParameterName];
                    }

                    params.includeModelEnvironment = true;

                    return params;
                }
            },

            postProcess: function (loadedDataSet, more) {
                var modelEnv = new InvData.ModelEnvironment();
                modelEnv.mergeEnvironmentData(loadedDataSet.modelEnvironment);

                var dataSet: any = {
                    modelEnv: modelEnv,
                    entityIds: loadedDataSet.entityIds,
                    investmentIds: loadedDataSet.investmentIds
                };

                var resourceIds = [];
                var assetParameterList = includeAssetsAsParameterList ? [] : null;

                if (includeResourceIds) {
                    $(dataSet.entityIds).each(function (i, entityId) {
                        var entity = modelEnv.getEntityById(entityId);
                        if (entity) {
                            resourceIds.push(entity.resourceId);
                            if (includeAssetsAsParameterList) {
                                assetParameterList.push({
                                    entityId: entityId, label: entity.label, resourceId: entity.resourceId
                                });
                            }
                        }
                    });

                    $(dataSet.investmentIds).each(function (i, investmentId) {
                        var investment = modelEnv.getInvestmentById(investmentId);
                        if (investment) {
                            resourceIds.push(investment.resourceId);
                            if (includeAssetsAsParameterList) {
                                assetParameterList.push({
                                    investmentId: investmentId, label: investment.label, resourceId: investment.resourceId
                                });
                            }
                        }
                    });

                    dataSet.resourceIds = resourceIds;
                    dataSet.assetParameterList = assetParameterList;
                }

                return dataSet;
            }
        };

        return dataSourceForSelectionSetContents
    }


    /**
     * Options should include dataSourceName, permissions.
     */
    export function getSecurityCheckDataSource(options) {
        var dataSourceName = options.dataSourceName;
        var permissions = options.permissions;

        return {
            name: dataSourceName,
            path: "/Solovis/Security/CurrentUserSecurityCheck",
            parameterMap: function (parameters) {
                var params = {
                    permissions: permissions
                };

                return params;
            },

            postProcess: function (loadedDataSet) {
                var dataSet = {};

                if (loadedDataSet.permissions) {
                    $(loadedDataSet.permissions).each(function (i, permission: any) {
                        dataSet[permission.name] = permission.allowed;
                    });
                }

                return dataSet;
            }
        };
    }


    /**
     * Retrieve property values for a list of resources.
     * Options should include dataSourceName, dependsOn, resourceListDataSetPath, propertiesParameters, asOfDateParameter.
     * Optional options are resourceIdGetter.
     * @param options
     */
    export function getResourcePropertyValuesDataSource(options) {      
        var dataSourceName = options.dataSourceName;
        var dependsOn = options.dependsOn ? options.dependsOn : null;
        var propertiesParameter = options.propertiesParameter ? options.propertiesParameter : null;
        var asOfDateParameter = options.asOfDateParameter ? options.asOfDateParameter : null;
        var asOfDateGetter = options.asOfDateGetter ? options.asOfDateGetter : null;

        // resourceListDataSetPath should be a path such as "dataSets.myDataSet.entityList" that maps
        // to an array where the objects have resourceId property.
        var resourceListDataSetPath = options.resourceListDataSetPath;

        // resourceIdGetter should be a function with signature function (item, more) which returns resourceId for the item.
        var resourceIdGetter = options.resourceIdGetter ? options.resourceIdGetter : null;

        return {
            name: dataSourceName,
            path: "/Solovis/Metadata/SpecificResourcePropertyValues",

            dependsOn: dependsOn,

            parameterMap: function (parameters, more) {
                var propDefIdList = [];
                var resourceIdList = [];

                if (propertiesParameter) {
                    var properties = parameters[propertiesParameter];

                    if (properties) {
                        $(properties).each(function (i, prop) {
                            propDefIdList.push(prop.id);
                        });
                    }
                }

                var resourceSourceList = Solovis.resolveObject(resourceListDataSetPath, more);

                if (resourceSourceList) {
                    $(resourceSourceList).each(function (i, resource: any) {
                        var resourceId;

                        if (resourceIdGetter) {
                            resourceId = resourceIdGetter(resource, more);
                        }
                        else {
                            resourceId = resource.resourceId;
                        }

                        if (resourceId) {
                            resourceIdList.push(resourceId);
                        }
                    });
                }

                var dayId = null;
                if (asOfDateGetter) {
                    dayId = asOfDateGetter(parameters);
                }
                else if (asOfDateParameter) {
                    dayId = parameters[asOfDateParameter];
                }

                var requestedValueSets = [
                    {
                        resourceIds: resourceIdList,
                        propDefIds: propDefIdList,
                        dayIds: [dayId]
                    }
                ];

                var params = {
                    requestedValueSets: requestedValueSets,
                    includeValueStrings: true,
                    includeMetadata: true
                };

                return params;
            },

            postProcess: function (loadedDataSet, more) {
                var dataSet: any = {};

                var modelEnv = new InvData.ModelEnvironment();
                modelEnv.mergeEnvironmentData(loadedDataSet.modelEnvironment);

                dataSet.modelEnvironment = modelEnv;

                // Add property definitions to the rows.                

                $(loadedDataSet.propertyValues).each(function (i, propValue) {
                    Solovis.Reports.StandardDataSources._updateResourcePropertyValue(propValue, modelEnv);
                });

                // Create maps from resource/propDefId to property values.
                dataSet.resourceIdToPropValueMap = {};

                $(loadedDataSet.propertyValues).each(function (i, propValue: any) {
                    var propIdToValueMap;
                    if (dataSet.resourceIdToPropValueMap[propValue.resourceId]) {
                        propIdToValueMap = dataSet.resourceIdToPropValueMap[propValue.resourceId];
                    }
                    else {
                        propIdToValueMap = {};
                        dataSet.resourceIdToPropValueMap[propValue.resourceId] = propIdToValueMap;
                    }

                    propIdToValueMap[propValue.propertyDefinitionId] = propValue;
                });

                return dataSet;
            }
        };
    }


    export function _updateResourcePropertyValue(propValue, modelEnv) {
        var propDefId = propValue.propertyDefinitionId;

        var propTypeIds = InvData.PropertyTypeIds;

        var propDef = modelEnv.propertyDefinitions.tryGetById(propDefId);
        propValue.property = propDef;

        // Set up valueStrings/HtmlList.
        if (!propValue.valueStrings) {
            switch (propDef.propertyTypeId) {
                case propTypeIds["String"]:
                    propValue.valueStrings = propValue.value.s;
                    break;

                case propTypeIds["Boolean"]:
                    propValue.valueStrings = _.map(
                        propValue.value.b,
                        function (b) {
                            return b ? "Yes" : "No"
                        });
                    break;

                case propTypeIds["Integer"]:
                    propValue.valueStrings = _.map(
                        propValue.value.i,
                        function (i) {
                            return i.toString();
                        });
                    break;

                case propTypeIds["Date"]:
                    propValue.valueStrings = _.map(
                        propValue.value.dt,
                        function (dayId) {
                            return InvData.Util.DateIndexHelper.formatDateIndexAsDateString(dayId as number);
                        });
                    break;
            }
        }
    }

}

